import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Navbar from '../navbar/navbar';
import HeroSection from '../heroSection/heroSection';
import EventProgram from '../eventProgram/eventProgram';
// import News from '../news/news';
// import RetroTech from '../retroTech/retroTech';
// import Fair from '../fair/fair';
// import FinnoWheel from '../finnoWheel/finnoWheel';
// import Accommodation from '../accommodation/accommodation';
import Gallery from '../gallery/gallery';
import Support from '../support/support';
import Footer from '../footer/footer';
import Seo from '../seo/seo';
import './app.css';

function App() {
  const { t } = useTranslation();
  const [activeButton, setActiveButton] = useState(null);

  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (!section) return;

    const navbar = document.querySelector('.navbar');
    const navbarHeight = navbar ? navbar.getBoundingClientRect().height : 0;
    const extraOffset = 24;

    const targetY = section.getBoundingClientRect().top + window.pageYOffset - navbarHeight - extraOffset;

    window.scrollTo({
      top: Math.max(0, targetY),
      behavior: 'smooth',
    });
  };

  const museumNightPhotos = Array.from({ length: 63 }, (_, index) => `/images/2026/MO/${index + 1}.jpg`);
  const museumNightGallery = [{ author: '', photos: museumNightPhotos }];
  const finnoWheelPhotos = Array.from({ length: 24 }, (_, index) => `/images/2026/MO/SUR/${index + 2}.jpg`);
  const finnoWheelGallery = [{ author: '', photos: finnoWheelPhotos }];

  return (
    <div className="App">
      <Seo />
      <Navbar activeButton={activeButton} setActiveButton={setActiveButton} scrollToSection={scrollToSection} />
      <main>
        <HeroSection setActiveButton={setActiveButton} scrollToSection={scrollToSection} />
        <EventProgram id="museum-night-2026" title={t('postEvent.museumNight.title')} photo="/images/2026/MO/1.png" photoAlt={t('postEvent.museumNight.photoAlt')} paragraphs={t('postEvent.museumNight.paragraphs', { returnObjects: true })} />
        <Gallery id="museum-night-gallery" title={t('postEvent.museumNight.galleryTitle')} galleries={museumNightGallery} />
        <EventProgram id="finno-wheel-2026" title={t('postEvent.finnoWheel.title')} photo="/images/2026/MO/SUR/1.png" photoAlt={t('postEvent.finnoWheel.photoAlt')} paragraphs={t('postEvent.finnoWheel.paragraphs', { returnObjects: true })} />
        <Gallery id="finno-wheel-gallery" title={t('postEvent.finnoWheel.galleryTitle')} galleries={finnoWheelGallery} />
      {/* Старые разделы сохранены для быстрого восстановления:
      <EventProgram />
      <News />
      <RetroTech />
      <Fair />
      <FinnoWheel />
      <Accommodation />
      <Gallery />
      */}
        <Support />
      </main>
      <Footer />
    </div>
  );
}

export default App;
